import React from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const SubMenus = ({ data, isOpen, toggleSubMenu, depth = 0 }) => {
  const location = useLocation();
  const [openNested, setOpenNested] = React.useState({});

  const renderSubIcon = (icon, isActive) => {
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, {
        className: `text-lg min-w-[18px] ${isActive ? "text-white" : "text-gray-600"}`,
        size: 18,
      });
    }
    return icon;
  };

  // Active = the longest sibling route the URL starts with,
  // so "/whatsapp/monitor" lights up only "WhatsApp Monitor", not "WhatsApp" too.
  const matches = (route) => route && route !== "-" && location.pathname.startsWith(route);
  const isActiveRoute = (route) => {
    if (!matches(route)) return false;
    return !(data?.menus || []).some((m) => m.route && m.route.length > route.length && matches(m.route));
  };

  const toggleNested = (index) => {
    setOpenNested((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <>
      <li
        className={`flex items-center gap-2 px-3 py-2.5 rounded-lg cursor-pointer transition-all ${isActiveRoute(data?.baseRoute)
          ? "bg-primary text-white shadow-md"
          : "hover:bg-primary/10 hover:text-primary text-gray-600"}`}
        onClick={toggleSubMenu}
        style={{ marginLeft: `${depth * 10}px` }}
      >
        {data?.icon && React.cloneElement(data?.icon, {
          className: `text-lg min-w-[18px] ${isActiveRoute(data?.baseRoute) ? "text-white" : "text-gray-600"}`,
          size: 18,
        })}
        <span className="flex-1 capitalize font-medium">{data?.name}</span>
        {data?.menus && (
          <RiArrowDropDownLine
            className={`text-xl transition-transform ${isOpen ? "rotate-180" : "rotate-0"} 
            ${isActiveRoute(data?.baseRoute) ? "text-white" : "text-gray-500"}`}
          />
        )}
      </li>

      <motion.ul
        initial={false}
        animate={{
          height: isOpen ? "auto" : 0,
          opacity: isOpen ? 1 : 0,
          paddingTop: isOpen ? "0.5rem" : 0,
          paddingBottom: isOpen ? "0.5rem" : 0
        }}
        transition={{ duration: 0.2 }}
        className="overflow-hidden flex flex-col pl-2 gap-1"
      >
        {data?.menus?.map((item, index) => {
          if (!item?.name) return null;

          if (item.menus) {
            // Recursive call for nested menus
            return (
              <SubMenus
                key={index}
                data={item}
                isOpen={openNested[index]}
                toggleSubMenu={() => toggleNested(index)}
                depth={depth + 1}
              />
            );
          }

          return (
            <NavLink
              key={index}
              to={item.route}
              className={`flex items-center gap-2 px-4 py-2 rounded-md transition-colors ${isActiveRoute(item.route)
                ? "bg-primary text-white shadow-sm"
                : "hover:bg-primary/10 hover:text-primary text-gray-600"
                }`}
              style={{ marginLeft: `${depth * 10}px` }}
            >
              {renderSubIcon(item.icon, isActiveRoute(item.route))}
              <span className="text-sm font-medium">{item.name}</span>
            </NavLink>
          );
        })}
      </motion.ul>
    </>
  );
};

export default SubMenus;